// extracted by mini-css-extract-plugin
module.exports = {"heading":"section_members_heading__Qk4n7","member_wrapper":"section_members_member_wrapper__g9_EK"};